import * as styles from './SavedReportsCell.module.css';

/**
 * Normalize savedReports to an array of names (API returns string[]).
 * @param {string[]|null|undefined} savedReports
 * @returns {string[]}
 */
export function toReportNamesArray(savedReports) {
  if (!Array.isArray(savedReports)) return [];
  return savedReports.filter((s) => s != null && s !== '');
}

export function SavedReportsCell({ savedReports }) {
  const names = toReportNamesArray(savedReports);

  if (names.length === 0) {
    return '-';
  }

  const firstName = names[0];

  return (
    <div className={styles['saved-reports-container']}>
      <div className={styles['cell-overflow-ellipsis']}>{firstName}</div>
      {names.length > 1 && (
        <div className={styles['saved-reports-more']}>+{names.length - 1}</div>
      )}
    </div>
  );
}
